module.exports = __webpack_public_path__ + "img/Fires-Land-Cover-Dashboard.2fbed936.png";